var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.version,staticClass:"abstretch p-3 text-light",staticStyle:{"overflow":"auto"}},[(_vm.displayGraph)?_c('render-display-graph',{attrs:{"data":_vm.displayGraph}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }